import 'core-js/actual';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from '@/shared/ui';
import { BASE_WIDTH } from '@/constants';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const tizen = (window as any).tizen;
if (tizen) {
  try {
    tizen.tvinputdevice.registerKey('MediaPlayPause');
    tizen.tvinputdevice.registerKey('MediaPlay');
    tizen.tvinputdevice.registerKey('MediaPause');
    tizen.tvinputdevice.registerKey('MediaStop');
    tizen.tvinputdevice.registerKey('MediaFastForward');
    tizen.tvinputdevice.registerKey('MediaRewind');
    tizen.tvinputdevice.registerKey('Home');
    tizen.tvinputdevice.registerKey('ArrowLeft');
    tizen.tvinputdevice.registerKey('ArrowUp');
    tizen.tvinputdevice.registerKey('ArrowRight');
    tizen.tvinputdevice.registerKey('ArrowDown');
    tizen.tvinputdevice.registerKey('Enter');
    tizen.tvinputdevice.registerKey('Back');
    tizen.tvinputdevice.registerKey('Exit');
  } catch (e) {
    console.error('Tizen RegisterKey error', e);
  }
}

function initialize() {
  const width = window.innerWidth;

  if (width <= 0) return;

  const zoom = (width / BASE_WIDTH) * 100;
  document.body.style.setProperty('zoom', `${zoom}%`);
}

window.addEventListener('DOMContentLoaded', initialize);
window.addEventListener('resize', initialize);
initialize();

root.render(
  <BrowserRouter basename={process.env.NODE_ENV === 'development' ? '/smart-tv' : ''}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </BrowserRouter>,
);
